import { ACCENT, BRAND, MUTED, TEXT } from "./shared/styles";

export default function WelcomeBanner({ onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9000,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        paddingTop: "22vh",
        background: "rgba(15, 23, 42, 0.45)",
        pointerEvents: "none"
      }}
    >
      <div
        style={{
          position: "relative",
          pointerEvents: "auto",
          width: "100%",
          maxWidth: 560,
          margin: "0 1.25rem",
          border: `1px solid ${ACCENT}`,
          borderRadius: "16px",
          padding: "1.5rem 2.6rem 1.5rem 1.75rem",
          background: "#fff",
          boxShadow: "0 20px 48px rgba(0, 17, 85, 0.22)"
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "1.15rem",
            fontWeight: 700,
            color: BRAND
          }}
        >
          Willkommen bei GreenOne
        </h2>
        <p style={{ margin: "0.5rem 0 0", fontSize: "0.92rem", lineHeight: 1.55, color: MUTED }}>
          der CO₂-Management-Plattform für Carrosserie- und Lackbetriebe. In wenigen Minuten
          erfahren Sie, wie Ihr Betrieb bei Energie, Lack und Reparatur aufgestellt ist — und
          wo Sie mit einfachen Anpassungen CO₂ und Kosten einsparen. Bereit? Dann legen Sie
          los mit dem ersten Schritt: Daten hinzufügen.
        </p>

        <button
          type="button"
          onClick={onClose}
          aria-label="Nachricht schliessen"
          style={{
            position: "absolute",
            top: "0.7rem",
            right: "0.7rem",
            border: "none",
            background: "transparent",
            color: MUTED,
            fontSize: "1.25rem",
            lineHeight: 1,
            cursor: "pointer",
            padding: "0.25rem"
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}